import { defaultFormValues, FormValues } from "./FormValues";
import { DateTime } from "luxon";
import { Party } from "../enums/Party";
import { BeneficiaryRelationshipType } from "../enums/BeneficiaryRelationshipType";

export type BeneficiaryFormValues = FormValues & {
    personFilingIsBeneficiary: string,
    beneficiaryFirstName: string,
    beneficiaryLastName: string,
    beneficiaryDateOfBirth: string,
    personFilingFirstName: string,
    personFilingLastName: string,
    personFilingPhoneNumber: string,
    beneficiaryEmailAddress: string,
    beneficiaryPhoneNumber: string,
    beneficiaryStreetAddress: string,
    beneficiaryCity: string,
    beneficiaryState: string,
    beneficiaryZipCode: string,
    deceasedFirstName: string,
    deceasedLastName: string,
    deceasedDateOfBirth: string,
    deceasedRelationship: BeneficiaryRelationshipType,
    deceasedOtherRelationship: string,
    deceasedIsEmployee: string,
    makingClaimTo: string,
    isUnitedStatesPerson: string,
    hasBackupWithholding: string,
    benefitClaimant: string,
    taxIdentificationNumber: string,
    taxPayerDisclaimerAcknowledged: boolean,
    beneficiarySignature: string,
    beneficiarySignatureDate: string,
    optOutOfEmpathy: boolean
}

export const defaultBeneficiaryFormValues = {
    ...defaultFormValues,
    party: Party.BENEFICIARY,
    personFilingIsBeneficiary: '',
    beneficiaryFirstName: '',
    beneficiaryLastName: '',
    beneficiaryDateOfBirth: '',
    personFilingFirstName: '',
    personFilingLastName: '',
    personFilingPhoneNumber: '',
    beneficiaryEmailAddress: '',
    beneficiaryPhoneNumber: '',
    beneficiaryStreetAddress: '',
    beneficiaryCity: '',
    beneficiaryState: '',
    beneficiaryZipCode: '',
    deceasedFirstName: '',
    deceasedLastName: '',
    deceasedDateOfBirth: '',
    deceasedRelationship: '',
    deceasedOtherRelationship: '',
    deceasedIsEmployee: '',
    makingClaimTo: '',
    isUnitedStatesPerson: '',
    hasBackupWithholding: '',
    benefitClaimant: '',
    taxIdentificationNumber: '',
    taxPayerDisclaimerAcknowledged: false,
    beneficiarySignature: '',
    beneficiarySignatureDate: DateTime.now().toFormat('MM/dd/yyyy'),
    optOutOfEmpathy: false
}
